var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"space-y-2"},_vm._l((_vm.comments),function(comment){return _c('li',{key:comment.uuid},[_c('ApprovalRequestLineCommentLine',{attrs:{"comment":comment}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }